/**
 * Nettoie une chaîne de caractères en supprimant :
 * - les caractères invisibles ASCII (non-imprimables),
 * - les caractères potentiellement dangereux (XSS/SQL).
 *
 * @param value La chaîne à nettoyer
 * @returns La chaîne nettoyée
 */
export function cleanTitleValue(value: string | undefined): string {
  if (!value) return "";

  return value
    // Supprime les caractères invisibles
    .replace(/[\x00-\x1F\x7F]/g, "")
    // Supprime les caractères suspects (potentiellement dangereux)
    .replace(/[<>[\]{}.:"\\;]/g, "")
    // Supprime les doubles tirets (injection SQL classique)
    .replace(/--/g, "")
}